import authStorage from "src/utils/authStorage";

const getPermission = (roles) => {
  const perm = authStorage.getItem("@sacgpt:user");
  let parsedRoles = {};

  if (perm && perm.trim() !== "") {
    try {
      parsedRoles = JSON.parse(perm);
    } catch (e) {
      parsedRoles = {};
    }
  }

  const hasPermission = roles?.every(role => parsedRoles?.userGroup?.roles?.includes(role));
  return hasPermission || parsedRoles?.userType === "partner";
};

export default getPermission;
